export default function Hero() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, target: string) => {
    e.preventDefault();
    const el = document.querySelector(target) as HTMLElement | null;
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center bg-gradient-to-br from-background-50 via-background-100 to-primary-50/40 overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-20 right-10 w-96 h-96 rounded-full bg-primary-500/5 blur-3xl"></div>
        <div className="absolute bottom-10 left-20 w-80 h-80 rounded-full bg-accent-500/8 blur-3xl"></div>
      </div>

      <div className="relative w-full max-w-[1280px] mx-auto px-4 md:px-6 pt-[100px] pb-12 md:py-0">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-5">
              <i className="ri-fire-fill text-sm"></i>
              <span>实时追踪 · 全网热点</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-black text-foreground-950 leading-tight">
              吃瓜网每日大赛
              <br />
              <span className="text-primary-500">全网最热吃瓜资讯平台</span>
            </h1>

            <p className="text-base md:text-lg text-primary-700 font-medium mt-3 mb-5 font-heading">
              第一手明星爆料 · 每日大赛排名 · 安全直达不迷路
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[620px] mx-auto lg:mx-0">
              吃瓜网每日大赛官网，聚合全网最新娱乐爆料与明星大瓜，每日更新大赛完整视频与排名。本站提供吃瓜网入口与最新地址，确保安全直达，让您随时随地畅享最热吃瓜内容。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-6 mb-7">
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-timer-flash-line text-primary-600 text-sm"></i>
                </span>
                <div className="text-left">
                  <p className="text-xs text-foreground-500">更新频率</p>
                  <p className="text-sm font-semibold text-foreground-900">24小时滚动更新</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-vidicon-line text-accent-600 text-sm"></i>
                </span>
                <div className="text-left">
                  <p className="text-xs text-foreground-500">内容覆盖</p>
                  <p className="text-sm font-semibold text-foreground-900">全品类吃瓜追踪</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-shield-check-line text-primary-600 text-sm"></i>
                </span>
                <div className="text-left">
                  <p className="text-xs text-foreground-500">访问保障</p>
                  <p className="text-sm font-semibold text-foreground-900">安全直达防迷路</p>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#updates"
                onClick={(e) => handleScroll(e, '#updates')}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-flashlight-line"></i>
                立即吃瓜
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleScroll(e, '#ranking')}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg border-2 border-primary-200 text-primary-700 font-semibold text-sm hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-trophy-line"></i>
                查看今日榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full hidden lg:flex items-center justify-center">
            <div className="relative w-full max-w-[520px]">
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/20 via-accent-500/10 to-transparent rounded-2xl blur-xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20abstract%20entertainment%20news%20visual%2C%20warm%20red%20and%20gold%20color%20burst%2C%20floating%20social%20media%20elements%20with%20spotlight%20effects%2C%20trending%20topic%20vibe%2C%20magazine%20editorial%20style%2C%20energetic%20composition%2C%20clean%20modern%20digital%20art%2C%20no%20text%2C%20dramatic%20warm%20lighting%2C%20sophisticated%20aesthetic&width=1040&height=1040&seq=hero-main-visual&orientation=squarish"
                alt="吃瓜网每日大赛 - 娱乐热点聚合平台主视觉"
                className="relative w-full h-auto rounded-2xl object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}